import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { TrashListItem } from 'src/models/trashList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { TrashListCallbackStoreContract } from '../interfaces';

export class GetTheMineTrashModuleItemsForTheUserCallBack extends Callback<TrashListItem[]> {
	public constructor(
		private readonly store: TrashListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: TrashListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.MINE, this.queryIdentifier)) {
			return;
		}

		this.store.setMineTrashList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
